<template>
  <div class="v-form v-form__check check">
    <h1>Ввод вручную</h1>

    <v-alert :value="isError" elevation="2" dense type="error" dark transition="scale-transition"
      >Данный чек <br />
      уже участвует в акции</v-alert
    >

    <div class="check__wrap manual_check">
      <div class="check-container-input">
        <v-text-field
          outlined
          required
          placeholder="0000.00"
          type="string"
          label="Сумма"
          clearable
          class="check-input"
          :class="{ errorDate: !valid_manual_sum }"
          v-model="manual_sum"
          dense
          hide-details
          @input="validateManualSum"
        >
        </v-text-field>
        <div class="error-message-container">
          <p v-if="errors.sum" class="error-message">{{ errors.sum }}</p>
        </div>
      </div>

      <div class="check-container-input">
        <v-text-field
          outlined
          label="Дата и время"
          placeholder="ДД.ММ.ГГГГ ЧЧ:ММ"
          required
          clearable
          v-model="manual_date"
          class="check-input"
          :class="{ errorDate: !valid_manual_date }"
          dense
          v-mask="'##.##.#### ##:##'"
          hide-details
          @input="validateManualDate"
        >
        </v-text-field>
        <div class="error-message-container">
          <div v-if="errors.date" class="error-message">{{ errors.date }}</div>
        </div>
      </div>

      <div class="check-container-input">
        <v-text-field
          outlined
          label="ФН №"
          required
          clearable
          class="check-input"
          :class="{ errorDate: !valid_manual_fn }"
          v-model="manual_fn"
          dense
          placeholder="0000000000000000"
          v-mask="'################'"
          hide-details
          @input="validateManualFn"
        ></v-text-field>
        <div class="error-message-container">
          <div v-if="errors.fn" class="error-message">{{ errors.fn }}</div>
        </div>
      </div>

      <div class="check-container-input">
        <v-text-field
          outlined
          required
          label="ФД №"
          clearable
          class="check-input"
          :class="{ errorDate: !valid_manual_fd }"
          v-model="manual_fd"
          dense
          placeholder="0000000000"
          v-mask="'##########'"
          hide-details
          @input="validateManualFd"
        ></v-text-field>
        <div class="error-message-container">
          <div v-if="errors.fd" class="error-message">{{ errors.fd }}</div>
        </div>
      </div>

      <div class="check-container-input">
        <v-text-field
          outlined
          required
          label="ФП №"
          clearable
          class="check-input"
          :class="{ errorDate: !valid_manual_fp }"
          v-model="manual_fp"
          dense
          placeholder="0000000000"
          v-mask="'##########'"
          hide-details
          @input="validateManualFp"
        ></v-text-field>
        <div class="error-message-container">
          <div v-if="errors.fp" class="error-message">{{ errors.fp }}</div>
        </div>
      </div>
    </div>
    <v-btn :disabled="!isFormValid" depressed :loading="isLoading" color="primary" class="next-btn check-btn" @click="manual_send" block>
      <div class="btn-content-container">Отправить</div></v-btn
    >
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import { mapActions } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      isLoading: false,
      valid_manual_date: false,
      valid_manual_sum: false,
      valid_manual_fn: false,
      valid_manual_fd: false,
      valid_manual_fp: false,
      manual_sum: "",
      manual_date: "",
      manual_fn: "",
      manual_fd: "",
      manual_fp: "",
      user_id: jwt_decode(this.$cookies.get("cng_token"))["id"],
      isError: false,
      errors: {
        sum: "",
        date: "",
        fn: "",
        fd: "",
        fp: "",
      },
    };
  },
  computed: {
    isFormValid() {
      return this.valid_manual_sum && this.valid_manual_date && this.valid_manual_fn && this.valid_manual_fd && this.valid_manual_fp;
    },
  },

  methods: {
    async manual_send() {
      try {
        this.isLoading = true;
        this.isError = false;

        if (!this.valid_manual_date || !this.manual_date || !this.manual_sum || !this.manual_fn || !this.manual_fd || !this.manual_fp) {
          this.isLoading = false;
          throw new Error("All fields require");
        }
        const formattedSum = this.manual_sum.replace(",", ".");
        const splitDate = this.manual_date.split(" ");
        const convertDate = splitDate[0] + "T" + splitDate[1];

        const date = moment(convertDate.trim(), "DD.MM.YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ss");

        const { data } = await axios.post(`${process.env.VUE_APP_QR}`, {
          account_id: this.user_id,
          time: date,
          summary: formattedSum,
          fn: this.manual_fn,
          fd: this.manual_fd,
          fp: this.manual_fp,
          type: "manual",
          operation: 1,
        });

        if (data.data === "qrcode already exist") {
          this.isError = true;
        } else this.$router.push({ name: "LcSuccess" }).catch(() => {});
      } catch (error) {
        console.error(error.message);
      } finally {
        this.isLoading = false;
      }
    },

    validateManualSum(value) {
      const validSum = /^(?!0([.,]0+)?$)[1-9]\d*([.,]\d+)?$/;

      if (!value || value.includes("+") || !validSum.test(value)) {
        this.valid_manual_sum = false;
        this.errors.sum = "Введите корректную сумму";
      } else {
        this.valid_manual_sum = true;
        this.errors.sum = "";
      }
    },

    validateManualDate(value) {
      this.errors.date = "";
      this.valid_manual_date = true;

      if (!value || value.trim() === "") {
        this.errors.date = "Поле обязательно для заполнения";
        this.valid_manual_date = false;
        return;
      }

      const fullFormatRegex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2} ([01][0-9]|2[0-3]):([0-5][0-9])$/;
      const dateOnlyRegex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/;
      const timeOnlyRegex = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;

      if (fullFormatRegex.test(value)) {
        const splitDate = value.split(" ");
        const convertDate = splitDate[0] + "T" + splitDate[1];
        const formatData = moment(convertDate, "DD.MM.YYYY HH:mm");

        if (formatData.isAfter(moment().local())) {
          this.errors.date = "Дата не может быть в будущем.";
          this.valid_manual_date = false;
        } else {
          this.errors.date = "";
          this.valid_manual_date = true;
        }
        return;
      }

      if (dateOnlyRegex.test(value)) {
        this.errors.date = "Необходимо указать время в формате ЧЧ:ММ";
        this.valid_manual_date = false;
        return;
      }

      if (timeOnlyRegex.test(value)) {
        this.errors.date = "Необходимо указать дату в формате ДД.ММ.ГГГГ";
        this.valid_manual_date = false;
        return;
      }

      this.errors.date = "Введите корректную дату. Формат: ДД.ММ.ГГГГ ЧЧ:ММ";
      this.valid_manual_date = false;
    },
    validateManualFn(value) {
      if (!value) {
        this.valid_manual_fn = false;
        this.errors.fn = "Поле ФН обязательно для заполнения";
      } else {
        this.valid_manual_fn = true;
        this.errors.fn = "";
      }
    },
    validateManualFd(value) {
      if (!value) {
        this.valid_manual_fd = false;
        this.errors.fd = "Поле ФД обязательно для заполнения";
      } else {
        this.valid_manual_fd = true;
        this.errors.fd = "";
      }
    },
    validateManualFp(value) {
      if (!value) {
        this.valid_manual_fp = false;
        this.errors.fp = "Поле ФП обязательно для заполнения";
      } else {
        this.valid_manual_fp = true;
        this.errors.fp = "";
      }
    },

    ...mapActions({
      getUserNotification: "getUserNotification",
      getUserData: "getUserData",
    }),
  },
};
</script>

<style scoped>
.v-form.v-form__check.check {
  font-family: "PT Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  text-align: center;
  letter-spacing: -0.005em;
  gap: 12;
  color: #1a1a1a;
}
.v-form.check h1 {
  font-family: "PT Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;

  text-align: center;
  letter-spacing: -0.005em;
  margin-bottom: 50px;
  color: var(--text-color);
}
.check__wrap {
  gap: 0;
}
.check-container-input {
  margin-bottom: 15px;
}
.check__subtitle {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;

  letter-spacing: -0.015em;

  color: #1a1a1a;
  margin-bottom: 4px !important;
}
.check-btn {
  margin-top: 0;
}
.error-message-container {
  min-height: 20px;
  margin-top: 5px;
}

.error-message {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #d40808;
  margin-top: 0;
}

@media screen and (max-width: 4000px) and (min-width: 769px) {
  .v-form {
    max-width: 800px;
    width: 100%;
    border-radius: 10px;
    padding: 60px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-form.check h1 {
    font: 700 40px "PT Sans";
    line-height: 110%; /* 44px */
    letter-spacing: -0.2px;
    margin-bottom: 0;
  }
  .btn-content-container {
    color: var(--white-color);
  }
  .check__wrap {
    width: 100%;
  }
}
</style>
